// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__10zmc","overflowing":"ReadFullNote_overflowing__3kjDv"};